/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SENSYN ID API
 * - ユーザー、組織情報の取得API
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetUsersInAnyOrganizationParams,
  OrganizationResponse,
  OrganizationsResponse,
  UserListResponse
} from '../model';

import getUsersInAnyOrganizationMutator from '../../../mutators/sensyn-id-instance';
import getAnyOrganizationMutator from '../../../mutators/sensyn-id-instance';
import getAllOrganizationsByAdminMutator from '../../../mutators/sensyn-id-instance';



  /**
 * - 指定組織のユーザー一覧を取得する For M2M
 * @summary getUsersInAnyOrganization
 */
export const getUsersInAnyOrganization = (
    organizationId: number,
    params?: GetUsersInAnyOrganizationParams,
 ) => {
      return getUsersInAnyOrganizationMutator<UserListResponse>(
      {url: `/internal/organizations/${organizationId}/users/`, method: 'GET',
        params
    },
      );
    }
  /**
 * - 指定組織の組織情報を取得する For M2M
 * @summary getAnyOrganization
 */
export const getAnyOrganization = (
    organizationId: number,
 ) => {
      return getAnyOrganizationMutator<OrganizationResponse>(
      {url: `/internal/organizations/${organizationId}/`, method: 'GET'
    },
      );
    }
  /**
 * - 全組織の組織一覧を取得する For M2M
 * @summary getAllOrganizationsByAdmin
 */
export const getAllOrganizationsByAdmin = (

 ) => {
      return getAllOrganizationsByAdminMutator<OrganizationsResponse>(
      {url: `/internal/organizations/`, method: 'GET'
    },
      );
    }
  export type GetUsersInAnyOrganizationResult = NonNullable<Awaited<ReturnType<typeof getUsersInAnyOrganization>>>
export type GetAnyOrganizationResult = NonNullable<Awaited<ReturnType<typeof getAnyOrganization>>>
export type GetAllOrganizationsByAdminResult = NonNullable<Awaited<ReturnType<typeof getAllOrganizationsByAdmin>>>
